/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import { FormErrorExamples as Examples } from './error_examples';

export class ReactiveErrors {
  static missingFormException(): void {
    throw new Error(`formGroup expects a FormGroup instance. Please pass one in.

       Example:

       ${Examples.formControlName}`);
  }

  static missingNameException(name: string) {
    throw new Error(
      `Control "${name}" not found!. If form-control is used within a az-form tag,  the name attribute must be set 

      Example: 
      
      ${Examples.missingName};
`);
  }
}
